<script>
  import Section from './Section.svelte';
  import {_} from '../locales/';
  const color = '#b117f8';
</script>

<style>
  .badge {
    background-color: #b117f8;
    border-bottom: 2px solid #6f0073;
    color: white;
    padding: 2px 5px;
    border-radius: 4px;
  }
</style>

<Section accent={color}>
  <div>
    <p>
      <span class="badge">{$_('news.new')}</span>
    </p>
    <p>
      {$_('news.backgroundThrottling')}
    </p>
  </div>
</Section>
